import React, { useState, useReducer, useContext, useEffect } from 'react';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Button, Snackbar, AppBar, Toolbar, IconButton, Typography, Backdrop, CircularProgress, Fab, Grid } from '@material-ui/core';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import CheckIcon from '@material-ui/icons/Check';
import WarningIcon from '@material-ui/icons/Warning';
import MuiAlert from '@material-ui/lab/Alert';
import styles from "../../jss/material-dashboard-react/views/dashboardStyle.js";
import Data from '../../data.js';
import { ConvertToCurrentTimeZone } from '../header/timeFormatter';
import { TransactionTime } from '../common/transactionTime';
import { GlobalTheme } from '../../layouts/theme.js';
import { Theme } from '../contexts/themeContext.js';
import { Context } from "../contexts/siteContext.js";
import { HttpService } from "../../apiAuthorization/httpService";
import { SCContext } from '../contexts/safetyCoachingContext.js';
import { SaveSafetyCoachingOfflineData } from "../../offline/dataService/safetyCoachingOfflineData";
import InactiveTimeout from '../common/inactiveTimeout';
import Card from "../card/card.js";
import CardBody from "../card/cardBody.js";
import GridItem from "../grid/gridItem.js";
import GridContainer from "../grid/gridContainer.js";
import SmallMenu from '../header/smallMenu';
import StatusIcon from '../common/statusIcon';

const useStyles = makeStyles(styles);
const safetyStyles = makeStyles({
    safeButton: {
        marginRight: '25px'
    }
});

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
};

export default function SafetyCoachingAdd(props) {
    const classes = useStyles();
    const safetyClasses = safetyStyles();
    const { defaultSite } = useContext(Context);
    const { theme } = useContext(Theme);
    const currentTheme = GlobalTheme[theme];
    const SafeStyles = {
        backgroundColor: 'green',
        color: 'white'
    };
    const UnsafeStyles = {
        backgroundColor: 'red',
        color: 'white'
    };
    const DefaultStyle = {
        backgroundColor: '#e0e0e0',
        color: 'black'
    };
    const edit = props.model.length === 0 ? false : true;
    const appSafetyCoachId = props.model.length === 0 ? 0 : props.model.AppSafetyCoachId;
    const action = props.model.length === 0 ? "Add" : "Edit";
    const jobTitles = Data.JobTitle;
    const categories = Data.Category;
    const { employees, getEmployees, supervisors, getSupervisors } = useContext(SCContext);
    const [activities, setActivities] = useState(edit ? categories[props.model.CategoryId - 1].Values : []);
    const [safeStyle, setSafeStyle] = useState(edit ? (props.model.IsSafe ? SafeStyles : {}) : {});
    const [unsafeStyle, setUnsafeStyle] = useState(edit ? (props.model.IsSafe === false ? UnsafeStyles : {}) : {});
    const [openError, setOpenError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('')
    const [backDrop, setBackDrop] = useState(false);
    const [modified, setModified] = useState(false);
    const [retrainingCompletedSelected, setRetrainingCompletedSelected] = useState(false);
    const [safetyCoach, setSafetyCoach] = useReducer(
        (state, newState) => ({ ...state, ...newState }),
        {
            AppSafetyCoachId: edit ? props.model.AppSafetyCoachId : 0,
            SiteId: defaultSite.id,
            JobTitleId: edit ? props.model.JobTitleId : "",
            CategoryId: edit ? props.model.CategoryId : "",
            ActivitiesId: edit ? props.model.ActivitiesId : "",
            SafetyCoachDate: edit ? props.model.SafetyCoachDate : ConvertToCurrentTimeZone(new Date(), "L", null, defaultSite),
            Employee: edit ? props.model.Employee : "",
            JobTitle: edit ? props.model.JobTitle : "",
            Supervisor: edit ? props.model.Supervisor : "",
            Category: edit ? props.model.Category : "",
            Activities: edit ? props.model.Activities : "",
            Other: edit ? props.model.Other : null,
            Comment: edit ? props.model.Comment : "",
            IsSafe: edit ? props.model.IsSafe : null,
            RetrainingCompleted: edit ? props.model.RetrainingCompleted : null,
            TransactionStart: edit ? props.model.TransactionStart : null,
            TransactionStartLocal: edit ? props.model.TransactionStartLocal : null,
            TransactionEnd: edit ? props.model.TransactionEnd : null,
            TransactionEndLocal: edit ? props.model.TransactionEndLocal : null,
            SessionDuration: edit ? props.model.SessionDuration : null,
            WarningCount: edit ? props.model.WarningCount : null
        }
    );

    const cancel = () => {
        props.parentCallback();
    };

    const closeErrorSnackbar = () => {
        setOpenError(false);
    };

    const saveSafetyCoach = (goBack) => {
        if (backDrop) {
            return;
        }
        else if (modified) {
            let message = "";

            if (safetyCoach.Employee === "")
                message = "Please select an Employee.";
            else if (safetyCoach.JobTitle === "")
                message = "Please select a Job Title.";
            else if (safetyCoach.Supervisor === "")
                message = "Please select a Supervisor.";
            else if (safetyCoach.Category === "")
                message = "Please select a Category.";
            else if (safetyCoach.Activities === "")
                message = "Please select or enter an Activity.";
            else if (safetyCoach.IsSafe === null)
                message = "Please click Safe or Unsafe.";

            if (message !== "") {
                setErrorMessage(message);
                setOpenError(true);
                return;
            }

            if (safetyCoach.IsSafe)
                safetyCoach.RetrainingCompleted = null;
            else
                safetyCoach.RetrainingCompleted = safetyCoach.RetrainingCompleted === "true";

            if (appSafetyCoachId === 0) {
                TransactionTime.end();
                TransactionTime.updateData(safetyCoach);
            }

            setBackDrop(true);
            HttpService.post('/SafetyCoaching/SaveAppSafetyCoach', safetyCoach)
                .then(async result => {
                    if (result && result.offline) {
                        let indexedDBId = await SaveSafetyCoachingOfflineData(defaultSite.id, appSafetyCoachId, "SaveAppSafetyCoach", safetyCoach, "/SafetyCoaching/SaveAppSafetyCoach", false, false);
                        if (safetyCoach.AppSafetyCoachId === 0)
                            safetyCoach.AppSafetyCoachId = "$" + indexedDBId;
                        props.refreshGrid(safetyCoach);
                        props.parentCallback();
                    }
                    else {
                        await SaveSafetyCoachingOfflineData(defaultSite.id, appSafetyCoachId, "SaveAppSafetyCoach", result.data, "/SafetyCoaching/SaveAppSafetyCoach", true, false);
                        props.refreshGrid(result.data);
                        props.parentCallback();
                    }
                },
                    (error) => {
                        console.log(error);
                    }
                );
        }
        else if (goBack) {
            props.parentCallback();
        }
    };

    useEffect(() => {
        if (employees.length === 0 || employees[0].TeamCoachId !== defaultSite?.IntegratedSystem?.TeamCoachId)
            getEmployees();
        if (supervisors.length === 0 || supervisors[0].TeamCoachId !== defaultSite?.IntegratedSystem?.TeamCoachId)
            getSupervisors();
        if (appSafetyCoachId === 0) {
            TransactionTime.begin("SafetyCoaching");
        }
        // eslint-disable-next-line 
    }, []);

    return (<>
        <Snackbar open={openError} autoHideDuration={3000} onClose={closeErrorSnackbar} style={{ height: "100%" }}>
            <Alert onClose={closeErrorSnackbar} severity="error">
                {errorMessage}
            </Alert>
        </Snackbar>
        <Backdrop className={classes.backdrop} id="safetyCoachBackdrop" open={backDrop}>
            <CircularProgress color="inherit" />
        </Backdrop>
        <AppBar style={{ background: currentTheme.primary, color: currentTheme.color }}>
            <Toolbar>
                <IconButton edge="start" color="inherit" onClick={() => saveSafetyCoach(true)} aria-label="back">
                    <KeyboardBackspaceIcon />
                </IconButton>
                <Grid container direction="row" alignItems="center">
                    <Grid item>
                        <Typography variant="h6" className={classes.title}>{action} Safety Coach</Typography>
                    </Grid>
                    <Grid item>
                        <StatusIcon />
                    </Grid>
                </Grid>
                <Grid container justify="flex-end" spacing={2}>
                    <Fab style={{ background: currentTheme.secondary, color: "white" }} size="small" aria-label="close" onClick={props.parentCallback}>
                        <CloseIcon />
                    </Fab>
                    <SmallMenu moduleName={"SafetyCoaching"} modified={modified} saveCallback={() => saveSafetyCoach(false)} />
                </Grid>
            </Toolbar>
        </AppBar>
        <GridContainer style={{ justifyContent: 'center' }}>
            <GridItem xs={12} sm={8} md={4}>
                <Card style={{ backgroundColor: currentTheme.background }}>
                    <CardBody style={{ color: currentTheme.text, marginTop: "50px", display: 'flex', justifyContent: 'center' }}>
                        <ValidatorForm className={classes.root} style={{ width: "100%", display: "block" }} autoComplete="off" onSubmit={() => saveSafetyCoach(false)}>
                            <TextValidator
                                select
                                required
                                variant="outlined"
                                id="Employee"
                                name="Employee"
                                label="Employee"
                                style={{ width: "100%" }}
                                value={safetyCoach.Employee}
                                onChange={(e) => {
                                    setSafetyCoach({ Employee: e.target.value });
                                    setModified(true);
                                }}
                                SelectProps={{ native: true }}
                                InputLabelProps={{ shrink: true }}
                            >
                                {safetyCoach.Employee === "" && <option value="" disabled>Select Employee</option>}
                                {employees.length > 0 && employees.map(option => (
                                    <option key={option.PplPerson} value={option.Title}>{option.Title}</option>
                                ))}
                            </TextValidator>
                            <br /><br />
                            <TextValidator
                                select
                                required
                                variant="outlined"
                                id="JobTitle"
                                name="JobTitle"
                                label="Job Title"
                                style={{ width: "100%" }}
                                value={safetyCoach.JobTitleId}
                                onChange={(e) => {
                                    setSafetyCoach({ JobTitleId: parseInt(e.target.value) });
                                    setSafetyCoach({ JobTitle: jobTitles[e.target.value - 1].Value });
                                    setModified(true);
                                }}
                                SelectProps={{ native: true }}
                                InputLabelProps={{ shrink: true }}
                            >
                                {safetyCoach.JobTitleId === "" && <option value="" disabled>Select Job Title</option>}
                                {jobTitles.length > 0 && jobTitles.map(option => (
                                    <option key={option.Id} value={option.Id}>{option.Text}</option>
                                ))}
                            </TextValidator>
                            <br /><br />
                            <TextValidator
                                select
                                required
                                variant="outlined"
                                id="Supervisor"
                                name="Supervisor"
                                label="Supervisor"
                                style={{ width: "100%" }}
                                value={safetyCoach.Supervisor}
                                onChange={(e) => {
                                    setSafetyCoach({ Supervisor: e.target.value });
                                    setModified(true);
                                }}
                                SelectProps={{ native: true }}
                                InputLabelProps={{ shrink: true }}
                            >
                                {safetyCoach.Supervisor === "" && <option value="" disabled>Select Supervisor</option>}
                                {supervisors.length > 0 && supervisors.map(option => (
                                    <option key={option.PplPerson} value={option.Title}>{option.Title}</option>
                                ))}
                            </TextValidator>
                            <br /><br />
                            <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                                <Button style={safeStyle}
                                    variant="contained"
                                    color="default"
                                    className={safetyClasses.safeButton}
                                    startIcon={<CheckIcon />}
                                    onClick={() => {
                                        setSafetyCoach({ IsSafe: true });
                                        setSafeStyle(SafeStyles);
                                        setUnsafeStyle(DefaultStyle);
                                        setModified(true);
                                    }}
                                >
                                    Safe
                                </Button>
                                <Button style={unsafeStyle}
                                    variant="contained"
                                    color="default"
                                    startIcon={<WarningIcon />}
                                    onClick={() => {
                                        setSafetyCoach({ IsSafe: false });
                                        setUnsafeStyle(UnsafeStyles);
                                        setSafeStyle(DefaultStyle);
                                        setModified(true);
                                    }}
                                >
                                    Unsafe
                                </Button>
                            </div>
                            <br />
                            <TextValidator
                                select
                                required
                                variant="outlined"
                                id="Category"
                                name="CategoryId"
                                label="Category"
                                style={{ width: "100%" }}
                                value={safetyCoach.CategoryId}
                                onChange={(e) => {
                                    setSafetyCoach({ CategoryId: parseInt(e.target.value) });
                                    setSafetyCoach({ Category: categories[e.target.value - 1].Key });
                                    setSafetyCoach({ ActivitiesId: "" });
                                    setSafetyCoach({ Activities: "" });
                                    setActivities(categories[e.target.value - 1].Values);
                                    setModified(true);
                                }}
                                SelectProps={{ native: true }}
                                InputLabelProps={{ shrink: true }}
                            >
                                {safetyCoach.CategoryId === "" && <option value="" disabled>Select Category</option>}
                                {categories.map(option => (
                                    <option key={option.Id} value={option.Id}>{option.Key}</option>
                                ))}
                            </TextValidator>
                            <br /><br />
                            {safetyCoach.CategoryId !== 5 && <TextValidator
                                select
                                required
                                variant="outlined"
                                id="Activity"
                                name="Activity"
                                label="Activity"
                                style={{ width: "100%" }}
                                value={safetyCoach.ActivitiesId}
                                onChange={(e) => {
                                    setSafetyCoach({ ActivitiesId: parseInt(e.target.value) });
                                    setSafetyCoach({ Activities: categories[safetyCoach.CategoryId - 1].Values[e.target.value - 1].Value });
                                    setModified(true);
                                }}
                                SelectProps={{ native: true }}
                                InputLabelProps={{ shrink: true }}
                            >
                                {safetyCoach.ActivitiesId === "" && <option value="" disabled>Select Activity</option>}
                                {activities.map(option => (
                                    <option key={option.Id} value={option.Id}>{option.Value}</option>
                                ))}
                            </TextValidator>
                            }
                            {safetyCoach.CategoryId === 5 && <TextValidator
                                required
                                variant="outlined"
                                name="Activity"
                                label="Activity"
                                validators={['required']}
                                errorMessages={['This field is required']}
                                style={{ width: "100%" }}
                                value={safetyCoach.Activities}
                                onChange={(e) => {
                                    setSafetyCoach({ ActivitiesId: 0 })
                                    setSafetyCoach({ Activities: e.target.value })
                                    setModified(true);
                                }}
                                InputLabelProps={{ shrink: true }}
                            />
                            }
                            <br /><br />
                            <TextField fullWidth multiline
                                rows="4"
                                variant="outlined"
                                id="Comments"
                                name="Comment"
                                label="Comments"
                                placeholder="Comments"
                                style={{ width: "100%" }}
                                value={safetyCoach.Comment}
                                onChange={(e) => {
                                    setSafetyCoach({ Comment: e.target.value });
                                    setModified(true);
                                }}
                                InputLabelProps={{ shrink: true }}
                            />
                            {(safetyCoach.IsSafe !== null && !safetyCoach.IsSafe) &&
                                <><br /><br />
                                    <FormControl component="fieldset" className={classes.formControl} style={{ display: "flex" }}>
                                        <FormLabel component="legend">Retraining Completed ? </FormLabel>
                                        <RadioGroup name="RetrainingCompleted" style={{ display: "block" }} value={safetyCoach.RetrainingCompleted} onChange={(e) => {
                                            setSafetyCoach({ RetrainingCompleted: e.target.value });
                                            setModified(true);
                                            setRetrainingCompletedSelected(true); // For allowing to edited value. As material -ui radio group is not working as expected so work around solution for this to make it work for add and edit
                                        }}>
                                            {!retrainingCompletedSelected && <FormControlLabel value="true" control={<Radio style={{ color: currentTheme.secondary }} />} checked={safetyCoach.RetrainingCompleted === true} label="Yes" />}
                                            {!retrainingCompletedSelected && <FormControlLabel value="false" control={<Radio style={{ color: currentTheme.secondary }} />} checked={safetyCoach.RetrainingCompleted === false} label="No" />}
                                            {retrainingCompletedSelected && <FormControlLabel value="true" control={<Radio style={{ color: currentTheme.secondary }} />} label="Yes" />}
                                            {retrainingCompletedSelected && <FormControlLabel value="false" control={<Radio style={{ color: currentTheme.secondary }} />} label="No" />}
                                        </RadioGroup>
                                    </FormControl>
                                </>
                            }
                            <br /><br />
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                style={{ background: currentTheme.secondary, width: "100px", float: "right" }}
                                startIcon={<SaveIcon />}
                                type="submit"
                            >
                                Save
                            </Button>
                        </ValidatorForm>
                    </CardBody>
                </Card>
            </GridItem>
            {(appSafetyCoachId === 0) && (
                <InactiveTimeout disContinue={cancel} />
            )}
        </GridContainer>
    </>
    )
}
